export default __webpack_public_path__ + "static/media/Sagar.abe1dfa0.jpg";